import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { WhyUsSection } from './components/WhyUsSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { FAQ } from './pages/FAQ';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/faq" element={<FAQ data-id="element-3" />} data-id="element-2" />
        <Route path="/" element={<div className="w-full min-h-screen bg-white" data-id="element-5">
              <Header data-id="element-6" />
              <main data-id="element-7">
                <HeroSection data-id="element-8" />
                <ServicesSection data-id="element-9" />
                <WhyUsSection data-id="element-10" />
                <BenefitsSection data-id="element-11" />
                <ContactSection data-id="element-12" />
              </main>
              <Footer data-id="element-13" />
            </div>} data-id="element-4" />
      </Routes>
    </BrowserRouter>;
}